import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/trash-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M268 416c-6.6 0-12-5.4-12-12v-216c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v216c0 6.6-5.4 12-12 12h-24zM432 80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16v336c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-336h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h82.4l34-56.7c7.7-12.9 26.2-23.3 41.2-23.3h0 100.8 0c15 0 33.4 10.4 41.2 23.3l34 56.7h82.4zM171.8 50.9l-17.5 29.1h139.2l-17.5-29.1c-1-1.6-3.3-2.9-5.1-2.9h0-94 0c-1.9 0-4.2 1.3-5.1 2.9zM368 464v-336h-288v336h288zM156 416c-6.6 0-12-5.4-12-12v-216c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v216c0 6.6-5.4 12-12 12h-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/trash-alt.js
// module id = 1828
// module chunks = 0